// libs
import React from 'react';

// contexts
import VirtualizeContext from 'shared/components/Virtualize/VirtualizeContext';

// defs
interface IRowProps {
  index: string | number;
  height: number;
  children: React.ReactNode;
}

class Row extends React.PureComponent<IRowProps> {
  public static contextType = VirtualizeContext;

  public componentDidMount() {
    const { height, children, index } = this.props;
    this.context.setRow(String(index), height, children);
  }

  public componentDidUpdate(prevProps: IRowProps) {
    if (this.props.height !== prevProps.height || this.props.children !== prevProps.children) {
      const { height, children, index } = this.props;
      this.context.setRow(String(index), height, children);
    }
  }

  public componentWillUnmount() {
    const { removeRow } = this.context;
    const { index } = this.props;
    removeRow(String(index));
  }

  public render() {
    return null;
  }
}

export default Row;
